import { t } from '../../../i18n/uiText';

/**
 * Вкладки разбора стиха — общие для панели под стихом и окна «Толкование».
 * id совпадает с блоком API /api/interpret/block; primary — основные, идут первыми.
 */
export const STUDY_TABS = [
  { id: 'meaning', labelKey: 'studyMeaning', primary: true },
  { id: 'simple', labelKey: 'studySimple', primary: true },
  { id: 'original', labelKey: 'originalTab', primary: true },
  { id: 'apply', labelKey: 'application', primary: true },
  { id: 'faq', labelKey: 'faqTab', primary: true },
  { id: 'context', labelKey: 'contextTab' },
  { id: 'theological', labelKey: 'theology' },
  { id: 'culture', labelKey: 'culture' },
];

export const DEFAULT_STUDY_TAB = 'meaning';

export function studyTabLabel(tab) {
  return t(tab.labelKey);
}

export function isStudyTab(id) {
  return STUDY_TABS.some((tab) => tab.id === id);
}
